export default {
  conversation: (state) => state.conversation,
  subjectCategory: (state) => state.subjectCategory,
  otherSubject: (state) => state.otherSubject,
  status: (state) => state.status,
  ticketId: (state) => state.ticketId,
};
